import { isVercelProduction } from "~/lib/vercel/constants"

import i18nProduction from "./i18n-production.json"
import i18n from "./i18n.json"

const i18nConfig = isVercelProduction ? i18nProduction : i18n

export { i18nConfig }
